export GiftIExtended from './GiftIExtended';


// WEBPACK FOOTER //
// ./src/common/components/formatter/index.jsx